import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "@/context/Auth";

export default function JoinPage() {
  const { code } = useParams();
  const { me, loading } = useAuth();
  useEffect(() => { sessionStorage.setItem("rangeo_invite", code); }, [code]);
  if (loading) return null;
  if (!me) return <Navigate to="/login" replace />;
  return <Navigate to={me.workspace ? "/" : "/onboarding"} replace />;
}
